import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { api } from '../api';
import { useAuth } from '../AuthContext';

export default function AcceptInvite() {
  const [sp] = useSearchParams();
  const token = sp.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const nav = useNavigate();
  // NB: accept-invite returns a JWT; we manually set it (no useAuth.signup path).
  const { user: _ } = useAuth(); // eslint-disable-line no-unused-vars

  async function submit(e) {
    e.preventDefault();
    setErr('');
    if (password !== confirm) { setErr('Passwords do not match'); return; }
    if (password.length < 8) { setErr('Password must be 8+ chars'); return; }
    setBusy(true);
    try {
      const res = await api.acceptInvite(token, password);
      api.setToken(res.token);
      window.location.href = '/mailbox';
    } catch (e) {
      setErr(e.message);
    } finally { setBusy(false); }
  }

  return (
    <div className="auth-split">
      <div className="auth-left">
        <div className="auth-card">
          <div className="auth-brand"><Link to="/">Rivet</Link></div>
          <h1>Accept your invite</h1>
          <p className="muted">Set a password and you're in.</p>
          {!token && <div className="chip risk">Missing invite token.</div>}
          <form onSubmit={submit}>
            <label className="field"><span className="label">Password (8+ chars)</span>
              <input className="input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
            </label>
            <label className="field"><span className="label">Confirm password</span>
              <input className="input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            </label>
            {err && <div className="chip risk" style={{ marginBottom: 12 }}>{err}</div>}
            <button className="btn" style={{ width: '100%' }} disabled={busy || !token}>Set password and sign in</button>
          </form>
        </div>
      </div>
      <div className="auth-right" style={{ backgroundImage: `linear-gradient(135deg, rgba(24,29,76,0.7), rgba(24,29,76,0.5))` }}>
        <div className="auth-right-inner">
          <div className="kicker light">Welcome to Rivet</div>
          <h2>You've been invited to a Rivet workspace.</h2>
        </div>
      </div>
    </div>
  );
}
